export const OPEN = 'Open'
export const AUDIT = 'Audit'
export const APPROVED = 'Approved'
export const DENIED = 'Denied'
export const SIGNED = 'Signed'
export const ONBOARDED = 'Onboarded'
